import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 28H3.05M25 24H25.05M7 24H7.05M29 28H29.05M2 20H2.05M30 20H30.05M16 25C13.7909 25 12 26.7909 12 29H20C20 26.7909 18.2091 25 16 25ZM16 25L16 21M16 6C14.3431 6 13 7.34315 13 9C13 7.34315 11.6569 6 10 6M16 6C17.6569 6 19 7.34315 19 9C19 7.34315 20.3431 6 22 6M16 6C16 4.34315 14.6569 3 13 3C11.3431 3 10 4.34315 10 6M16 6C16 4.34315 17.3431 3 19 3C20.6569 3 22 4.34315 22 6M22 6C23.6569 6 25 7.34315 25 9M7 9C7 7.34315 8.34315 6 10 6M16 21C22.0751 21 27 16.0751 27 10L5 10C5 16.0751 9.92487 21 16 21Z",
		stroke: "#DFCBF5",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSuccess;
